import CarouselServices from "../Services/CarouselServices";
import {useEffect, useState} from "react";

const NominationOptions = ({props, className}) => {
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 991);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return (
        <div className={`nomination-options flex ${className} j-end gap-16 mt-32`}>
            {!isMobile && props.map((item, i) =>
                <div key={i} className="flex center text-center gap-16 w-100 nomination-card">
                        <span className="options-span white fs-20">{item.year}</span>
                        <img src={item.img} alt={item.alt} className="img nominate-logo"/>
                        <span className="options-span white fs-20">{item.title}</span>
                        <span className="options-span white fs-20">{item.nominated}</span>
                        <span className="options-span white fs-20">{item.project}</span>
                        <span className="options-span white fs-20">{item.status}</span>
                </div>
            )}
            {isMobile && <CarouselServices props={props} />}
        </div>
    )
}
export default NominationOptions